<template>
  <unicom-linha class="unicom-linha">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Posto de Coleta</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <unicom-coluna sm="3" :class="espacamentoMobile">
      <Multiselect
        v-model="payload.tipoServicoEspecialidade"
        :propsMultiselect="{
          placeholder: 'Exames coletados',
          options: listaEspecialidades,
          'track-by': 'id',
          label: 'tipoServicoEspecialidade'
        }"
        v-show="clickSwitch"
      />
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="!outrosOpcao && clickSwitch"
    >
    </unicom-coluna>

    <unicom-coluna
      sm="1"
      :class="espacamentoMobile"
      v-if="outrosOpcao && clickSwitch"
    >
      <div align="right" style="font-size: 15px; padding-top: 8px">
        Outros:
      </div>
    </unicom-coluna>
    <unicom-coluna sm="4" :class="espacamentoMobile">
      <unicom-campo-texto
        ladoIcone="direito"
        :maxCaracteres="1500"
        clickIcone
        colorPlaceholder="#9E9E9E"
        placeholder="Outros Exames"
        v-model="payload.outro"
        v-if="outrosOpcao && clickSwitch"
      />
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import Multiselect from "@/views/RecursosPropriosQuestionarios/shared/Multiselect.vue";
import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    Multiselect
  },
  data() {
    return {
      payload: {
        tipoServico: "Posto de Coleta",
        tipoServicoEspecialidade: [],
        tipoServicoPublico: [],
        outro: ""
      },
      listaEspecialidades: [],
      outrosOpcao: false
    };
  },
  beforeMount() {
    this.inicializarEspecialidades();
  },
  methods: {
    inicializarEspecialidades() {
      return this.getEspecialidades(this.servico.id).then(({ data }) => {
        if (data) {
          this.listaEspecialidades = [...data];
        }
      });
    }
  },
  watch: {
    // "payload.tipoServicoEspecialidade": "checkEspecialidades",
    "payload.outro": "emitir",
    "payload.tipoServicoPublico": `emitir`,
    dadosServidor(newVal) {
      if (newVal.especialidades.length > 0) {
        newVal.especialidades.forEach(especialidade => {
          if (
            especialidade.tipoServico.tipoServico === this.payload.tipoServico
          ) {
            this.clickSwitch = true;
            this.preencheCampo(
              "especialidade",
              especialidade.tipoServicoEspecialidade
            );
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (
            servico.tipoServico.tipoServico === this.payload.tipoServico &&
            (servico.tipoServicoPublico || servico.outro)
          ) {
            this.clickSwitch = true;
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.preencheCampo("outro", servico.outro);
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.unicom-linha {
  margin-bottom: 24px;
}
.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}
</style>
